import { createGetAPI } from '@cuemath/rest-api';
import { BASE_URL } from 'constants/api';

const { useGet: useReviewDetailGet, invalidate: invalidateReviewDetail } = createGetAPI({
  getURL: reviewId => `${BASE_URL}/teacher-classroom-reviews/${reviewId}/`,
});

export { useReviewDetailGet, invalidateReviewDetail };
